import Vue from "vue";
import Router from "vue-router";
import loadConfig from "../resolvers/ConfigResolver.js";
import Store from "../store";

let router = new Router({
  mode: "history",

  routes: [
    {
      path: "/",
      meta: {
        name: "",
        requiresAuth: true,
      },
      redirect: {
        path: "/dashboard",
      },
    },
    // {
    //   path: "/login",
    //   name: "login",
    //   component: () => import("../view/LoginV2"),
    //   beforeEnter: (to, from, next) => {
    //     if (Store.getters["Login/authorized"]) {
    //       next("/dashboard");
    //     } else {
    //       next();
    //     }
    //   }
    // },
    // ADMINISTRAR
    {
      path: "/administrar",
      name: "Administrador",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../components/global/Layout"),
      beforeEnter: (to, from, next) => {
        Store.dispatch("Login/getUser").then(() => {
          next();
        });
      },
      children: [
        {
          path: "usuarios",
          name: "Usuários",
          component: () => import("../view/administrar/usuarios/Usuarios"),
        },
        {
          path: "perfis",
          component: () => import("../components/global/LayoutRoute"),
          children: [
            {
              path: "",
              name: "Consultar Perfil",
              component: () => import("../view/administrar/perfis/Perfis"),
              props: true,
            },
            {
              path: "form",
              name: "Incluir Perfil",
              component: () => import("../view/administrar/perfis/PerfisForm"),
              props: true,
            },
            {
              path: "form/:id",
              name: "Editar Perfil",
              component: () => import("../view/administrar/perfis/PerfisForm"),
              props: true,
            },
          ],
        },
        {
          path: "backup",
          name: "backup",
          component: () => import("../view/records/backup/Backup"),
        },
      ],
    },
    // TRANSLADO
    {
      path: "/translado",
      name: "Translado",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../components/global/Layout"),
      children: [
        {
          path: "entrada",
          name: "Translado Entrada",
          component: () => import("../view/translado/entrada/TransladoEntrada.vue"),
        },
        {
          path: "saida",
          name: "Translado Saída",
          component: () => import("../view/translado/saida/TransladoSaida.vue"),
        },
      ],
    },

    // MAPEAMENTO
    {
      path: "/mapeamento",
      name: "Mapeamento",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../components/global/Layout"),
      beforeEnter: (to, from, next) => {
        let menus = Store.getters["Config/getMenus"];

        Store.dispatch("Login/getUser").then(() => {
          let isOwner = false;
          menus.forEach((map) => {
            if (map.rota == to.path) {
              isOwner = true;
            }
          });
          isOwner ? next() : next("/401");
        });
      },
      children: [
        {
          path: "bilac",
          name: "Mapeamento Bilac",
          component: () => import("../view/mapeamento/bilac/MapeamentoBilac.vue"),
        },
      ],
    },

    // MAPEAMENTO FOTOS
    {
      path: "/v3/mapeamento-fotos",
      name: "MapeamentoV3-Fotos",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../view/mapeamento/mapeamentoFotos/MapboxFotos.vue"),
    },

    {
      path: "/teste",
      name: "teste",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../view/Teste.vue"),
    },

    {
      path: "/admin",
      name: "Adm Cemicloud",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../components/global/Layout"),
      beforeEnter: (to, from, next) => {
        Store.dispatch("Login/getUser").then(() => {
          next();
        });
      },
      children: [
        {
          path: "config",
          name: "Configurações",
          component: () => import("../view/admin/configuracoes/Configuracoes"),
        },
        {
          path: "usuarios",
          component: () => import("../components/global/LayoutRoute"),
          children: [
            {
              path: "",
              component: () => import("../view/admin/usuarios/Usuarios"),
              props: true,
            },
          ],
        },
        {
          path: "logs",
          component: () => import("../components/global/LayoutRoute"),
          children: [
            {
              path: "",
              name: "Consultar Logs",
              component: () => import("../view/admin/logs/Logs"),
              props: true,
            },
          ],
        },
        {
          path: "notificacoes",
          component: () => import("../components/global/LayoutRoute"),
          children: [
            {
              path: "",
              name: "Notificações ADM",
              component: () => import("../view/admin/notificacoes/Notificacoes"),
              props: true,
            },
            {
              path: "enviar",
              name: "Enviar Notificações",
              component: () => import("../view/admin/notificacoes/EnviarNotificacao"),
              props: true,
            },
          ],
        },
        {
          path: "acessos",
          component: () => import("../components/global/LayoutRoute"),
          children: [
            {
              path: "",
              name: "Acessos",
              component: () => import("../view/admin/acessos/Acessos"),
              props: true,
            },
          ],
        },
      ],
    },

    {
      path: "/v3/mapeamento",
      meta: {
        name: "",
        requiresAuth: true,
      },
      component: () => import("../components/global/LayoutMapeamento"),
      children: [
        {
          path: "",
          name: "MapeamentoV3",
          component: () => import("../view/mapeamento/mapbox/Mapbox"),
        },
      ],
    },

    {
      path: "/",
      meta: {
        name: "",
        requiresAuth: true,
      },
      name: "Layout",
      component: () => import("../components/global/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("../view/Dashboard"),
        },
        {
          path: "/cadastro/cemiterio",
          name: "Cadastro de Cemitério",
          component: () => import("../view/records/cemiterio/Cemiterio"),
        },
        {
          path: "/cadastro/quadra",
          name: "Cadastro de Quadra",
          component: () => import("../view/records/quadra/Quadra"),
        },
        {
          path: "/cadastro/responsavel",
          name: "Cadastro de Proprietario",
          component: () => import("../view/records/proprietario/Proprietario"),
        },
        // COVAS
        {
          path: "/cadastro/cova",
          name: "Cadastro de Cova",
          component: () => import("../view/records/cova/Cova"),
        },
        {
          path: "/cadastro/cova/:cdCova",
          name: "Formulario de Cova",
          component: () => import("../view/records/cova/Cova"),
        },
        {
          path: "/cadastro/funerarias",
          name: "Cadastro de Funerárias",
          component: () => import("../view/records/funerarias/Funerarias.vue"),
        },
        {
          path: "/cadastro/falecido/:id",
          name: "Formulario de Falecido",
          component: () => import("../view/records/falecido/Falecido"),
        },
        {
          path: "/cadastro/falecido",
          name: "Cadastro de Falecido",
          component: () => import("../view/records/falecido/Falecido"),
        },
        {
          path: "v2/processo/sepultamento",
          name: "EnterroV2",
          component: () => import("../view/processo/sepultamento/SepultamentoV2"),
        },
        {
          path: "/processo/vendadecovas",
          name: "Venda de Cova",
          component: () => import("../view/processo/vendacova/VendaCova"),
        },
        {
          path: "/processo/coletaderesiduos",
          name: "Coleta de Residuos",
          component: () => import("../view/processo/coletaderesiduos/ColetaDeResiduos"),
        },
        {
          path: "/financeiro/sepultamento",
          name: "Financeiro Sepultamento",
          component: () => import("../view/financeiro/Sepultamento/Sepultamento"),
        },
        {
          path: "/financeiro/vendadecovas",
          name: "Financeiro Venda de covas",
          component: () => import("../view/financeiro/VendaCova/VendaCova"),
        },
        {
          path: "/financeiro/funerarias",
          name: "Financeiro Funerárias",
          component: () => import("../view/financeiro/Funerarias/Funerarias"),
        },
        {
          path: "/perfil",
          name: "Perfil",
          component: () => import("../view/general/perfil/Perfil"),
        },
        {
          path: "/chamados",
          name: "Chamados",
          component: () => import("../view/chamados/ListaDeChamados"),
        },
        {
          path: "/novo-chamado",
          name: "Novo Chamado",
          component: () => import("../view/chamados/NovoChamado"),
        },
        {
          path: "chamado/:id",
          name: "Chamado",
          component: () => import("../view/chamados/Chamado"),
        },
        {
          path: "/notificacoes",
          name: "Notificações",
          component: () => import("../view/notificacoes/Notificacoes"),
        },
        {
          path: "/v2/mapeamento",
          name: "MapeamentoV2",
          component: () => import("../view/mapeamento/v2/Mapeamento"),
        },
        {
          path: "/v3/mapeamento-2",
          name: "MapeamentoV3-2",
          component: () => import("../view/mapeamento/mapbox/Mapbox2"),
        },
        {
          path: "/v1/mapeamento",
          name: "MapeamentoBilac",
          component: () => import("../view/mapeamento/bilac/MapeamentoBilac.vue"),
        },
        {
          path: "/exumacao-translado/",
          name: "exumacaotranslado",
          component: () => import("../view/processo/exumacaotranslado/ExumacaoTranslado"),
          children: [
            {
              path: ":id/edit",
              name: "exumacaotranslado.edit",
              component: () => import("../view/processo/exumacaotranslado/ExumacaoTransladoForm"),
              props: true,
            },
            {
              path: ":id/visualizar",
              name: "exumacaotranslado.visualizar",
              component: () => import("../view/processo/exumacaotranslado/ExumacaoTransladoForm"),
              props: true,
            },
            {
              path: "new",
              name: "exumacaotranslado.new",
              component: () => import("../view/processo/exumacaotranslado/ExumacaoTransladoForm"),
              props: true,
            },
          ],
        },
        {
          path: "/digitacao/livros",
          name: "Digitação Livros",
          component: () => import("../view/administrar/digitacao/DigitacaoLivros"),
        },
        {
          path: "/401",
          name: "401",
          component: () => import("../view/Unauthorized"),
        },
      ],
    },
    { path: "*", redirect: "/" },
  ],
});

router.beforeEach(async (to, from, next) => {
  await loadConfig(to, from, next);
  const user = await Store.dispatch("Login/getUser");
  const menus = Store.getters["Config/getMenus"];

  const menu = getMenuPorPath(menus, to.path);
  if (menu) {
    const roles = menu.funcionalidades.map((f) => f.identificador);

    if (!roles.some((role) => user.roles.includes(role))) next("/401");
  }
  next();
});

function getMenuPorPath(menus, path) {
  let aux = undefined;
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].rota == path) {
      return menus[i];
    }
    aux = getMenuPorPath(menus[i].subMenus, path);
    if (aux) return aux;
  }
}

export default router;

Vue.use(Router);
